module.exports = __webpack_public_path__ + "img/orange_024.08b0b3eb.png";